import {
  AutomationConfig_UserStatus,
  type AutomationConfig,
} from "@smartsuite/automation-engine-api";
import { t } from "i18next";
import { useRootStore } from "../../../stores/hooks";
import { Colors } from "@smartsuite/types";

interface ConfirmModals {
  showConfirmationModal: (
    showOnOffModal: boolean,
    submit: (forDuplicatingAutomation?: AutomationConfig) => Promise<void>,
    forDuplicatingAutomation?: AutomationConfig,
  ) => void;
}

export const useConfirmModals = (): ConfirmModals => {
  const { modal, automations } = useRootStore();

  const showConfirmationModal = (
    showOnOffModal: boolean,
    submit: (forDuplicatingAutomation?: AutomationConfig) => Promise<void>,
    forDuplicatingAutomation?: AutomationConfig,
  ): void => {
    if (automations.candidate.isCanBeSubmitted()) {
      if (automations.candidate.isTriggerIsRecordUpdatedAndHasNoConditions()) {
        showNoConditionsModal(showOnOffModal, submit, forDuplicatingAutomation);
      } else if (!automations.candidate.isActiveStatus() && showOnOffModal) {
        showConfirmationOffModal(
          showOnOffModal,
          submit,
          forDuplicatingAutomation,
        );
      } else {
        void submit(forDuplicatingAutomation);
      }
    } else {
      automations.candidate.setSubmitted();
    }
  };

  const showNoConditionsModal = (
    showOnOffModal: boolean,
    submit: (forDuplicatingAutomation?: AutomationConfig) => Promise<void>,
    forDuplicatingAutomation?: AutomationConfig,
  ): void => {
    modal.openConfirmModal({
      type: "warning",
      title: t("confirm-modal.are-you-sure"),
      description: `${t(
        "confirm-modal.no-conditions-description",
      )} <a href="https://help.smartsuite.com/en/articles/6464896-automation-conditions"  target="_blank"  style="color: ${
        Colors.custom15
      };text-decoration: underline;cursor: pointer;">${t("learn-more2")}</a>`,
      negativeButtonText: t("general.cancel"),
      positiveButtonText: t("confirm-modal.save-changes"),
      hasUnsavedChanges: true,
      onClose: () => {
        modal.closeConfirmModal();
      },
      onConfirm: () => {
        if (!automations.candidate.isActiveStatus() && showOnOffModal) {
          modal.closeConfirmModal();
          showConfirmationOffModal(
            showOnOffModal,
            submit,
            forDuplicatingAutomation,
          );
        } else {
          modal.closeConfirmModal();
          void submit(forDuplicatingAutomation);
        }
      },
    });
  };

  const showConfirmationOffModal = (
    showOnOffModal: boolean,
    submit: (forDuplicatingAutomation?: AutomationConfig) => Promise<void>,
    forDuplicatingAutomation?: AutomationConfig,
  ): void => {
    modal.openConfirmModal({
      type: "confirm",
      title: t("confirm-modal.automation-is-off"),
      description: t("confirm-modal.switch-it-on"),
      positiveButtonText: t("confirm-modal.yes-switch-it-on"),
      negativeButtonText: t("confirm-modal.no-keep-it-off"),
      showCheckbox: true,
      onClose: () => {
        modal.closeConfirmModal();
        void submit(forDuplicatingAutomation);
      },
      onConfirm: () => {
        automations.candidate.updateStatus(
          AutomationConfig_UserStatus.USER_ENABLED,
        );
        void submit(forDuplicatingAutomation);
        modal.closeConfirmModal();
      },
      onChangeCheckbox: () => {
        localStorage.setItem("showOnOffModal", String(!showOnOffModal));
      },
    });
  };

  return {
    showConfirmationModal,
  };
};
